import { render } from "./VerticalLayout.vue?vue&type=template&id=4a788060"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"
script.render = render

export default script